<script lang="ts" setup>
import CoreAppLogo from '#core/components/Core/CoreLogo.vue'

// We override the core CoreLogo and re-render it with the own badge

defineOptions({
  inheritAttrs: false,
})
defineProps<{ dark?: boolean, collapsed?: boolean }>()

const auth = useAuth()
</script>

<template>
  <CoreAppLogo :dark="dark" :collapsed="collapsed" v-bind="$attrs" :app-name="auth.isAdvisor ? 'Advisor portal' : ''" />
</template>
